module.exports = __webpack_public_path__ + "media/Monako_Final_2024.6f33cf85.mp4";